import { Input, InputProps, InputRef } from 'antd'
import clsx from 'shared/libs/clsx'

import { forwardRef } from 'react'

import './TextFiled.css'

type Props = InputProps & {
  withPlaceholder?: boolean
}

const TextFiled = forwardRef<InputRef, Props>(
  (
    { className, withPlaceholder = true, placeholder, ...props }: Props,
    ref,
  ) => {
    return (
      <Input
        rootClassName={clsx('customTextFiled', className)}
        placeholder={withPlaceholder ? placeholder : ''}
        ref={ref}
        {...props}
      />
    )
  },
)

export default TextFiled
